import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { OurSponsorsService } from './our-sponsors.service';

@Component({
    selector: 'app-our-sponsors',
    templateUrl: './our-sponsors.component.html',
    styleUrls: ['./our-sponsors.component.scss']
})
export class OurSponsorsComponent implements OnInit {

	public logos: any;

    constructor(
		private content: OurSponsorsService,
        public router: Router
	) {
		
        this.content.getClientsLogo().subscribe((data: any) => {
            this.logos = data;
		});
		
	}

    ngOnInit(): void {
    }

    sponsorsSlides: OwlOptions = {
		margin: 25,
        loop: true,
		nav: false,
		dots: false,
		autoplay: true,
		smartSpeed: 500,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 2
			},
			576: {
				items: 3
			},
			768: {
				items: 5
			},
			1024: {
				items: 5
			},
			1200: {
				items: 8
			}
		}
    }

}